<template>
    <div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                <i class="fas fa-hourglass-half"></i>&nbsp;Waiting for seller to schedule shipment.
            </p>
            <div class="card-body text-center">
                <p class="text-center aboutscroll">
                    After the schedule shipment, buyer will ship the commodities only then you can release payment. If you wish to dispute this transaction, please click on Open Dispute button below.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SchedulePending"
    }
</script>

<style scoped>

</style>